import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import store from './store';

import 'bootstrap/scss/bootstrap.scss';
import 'font-awesome/scss/font-awesome.scss';
import 'rc-slider/assets/index.css';
import '../styles/style.scss';
import 'react-image-lightbox/style.css';
import {HelmetProvider} from 'react-helmet-async';

const render = () => {
    ReactDOM.render(
        <HelmetProvider>
            <App store={store} />
        </HelmetProvider>,
        document.getElementById('app-root'),
    );
};

render();

if (module.hot) {
    module.hot.accept(render);
}
